import { FC } from "react";

import { Row, Column, ModelIcon } from "@hightouch/htui";

import { SelectorRow } from "src/components/explore/selector-row";
import { SqlEditor } from "src/components/sql-editor";
import { UnsavedValue } from "src/hooks/use-unsaved-value";
import { QueryableSource } from "src/types/models";
import {
  QueryContainer,
  QueryHeader,
  QueryHeaderTitle,
} from "src/components/query";

type Props = {
  source: QueryableSource;
  onSQLChange?: (sql: string) => void;
  sql: string;
  unsavedSql?: UnsavedValue<string>;
  queryErrorAtLine?: number;
};

export const SampleModelSelector: FC<Readonly<Props>> = ({
  source,
  onSQLChange,
  sql,
  unsavedSql,
  queryErrorAtLine,
}) => {
  return (
    <Row overflow="hidden" gap={4} flex={1}>
      <QueryContainer>
        <QueryHeader>
          <QueryHeaderTitle title="Sample queries" />
        </QueryHeader>

        <Column overflow="auto" flex={1}>
          {source?.definition?.sampleModels?.map((model) => {
            return (
              <SelectorRow
                key={model?.name ?? ""}
                icon={<ModelIcon />}
                selected={model?.sql === sql}
                onClick={() => {
                  onSQLChange?.(model?.sql ?? "");
                }}
              >
                {model?.name}
              </SelectorRow>
            );
          })}
        </Column>
      </QueryContainer>

      <Column flex={1}>
        <SqlEditor
          highlightErroredLine={queryErrorAtLine}
          placeholder={
            source?.definition?.isSampleDataSource === true
              ? "Select a sample model or enter a custom query…"
              : "Enter your query…"
          }
          source={source ?? undefined}
          unsavedValue={unsavedSql}
          value={sql ?? ""}
          onChange={onSQLChange}
        />
      </Column>
    </Row>
  );
};
